import { getUtmContent } from "./utm";
import { getRef } from "./ref";

const API = process.env.REACT_APP_BACKEND_URL;

export const networkFromPath = (pathname) => {
  const seg = pathname.split("/")[1];
  return ["facebook", "youtube", "instagram", "linkedin"].includes(seg) ? seg : "hub";
};

export const track = (event, network, extra = {}) => {
  if (sessionStorage.getItem("hv_stats_key")) return; // don't count the owner's own visits
  fetch(`${API}/api/track`, {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event,
      network,
      path: window.location.pathname,
      referrer: document.referrer,
      content: getUtmContent(),
      ref: getRef(),
      ...extra,
    }),
  }).catch(() => {});
};
